const getters = {
  getSedes: state => state.sedes,
  getUltimaSede: state => state.ultimaSede
}

export default getters
